export default __webpack_public_path__ + "static/media/GOLD CLASS.d539e81f.jpg";